export const toNumberOrZero = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const getServiceTotalFee = (service) => {
  if (!service || typeof service !== "object") return null;

  const hasAnyFeeKey =
    service.DoctorFee != null ||
    service.HospitalFee != null ||
    service.ServiceFee != null;

  if (!hasAnyFeeKey) return null;

  return (
    toNumberOrZero(service.DoctorFee) +
    toNumberOrZero(service.HospitalFee) +
    toNumberOrZero(service.ServiceFee)
  );
};

export const getDoctorProfileTotalFee = (doctor) => {
  if (!doctor || typeof doctor !== "object") return null;

  const hasAnyFeeKey =
    doctor.doctorFee != null ||
    doctor.hospitalFee != null ||
    doctor.serviceFee != null ||
    doctor.otherFee != null;

  if (!hasAnyFeeKey) return null;

  return (
    toNumberOrZero(doctor.doctorFee) +
    toNumberOrZero(doctor.hospitalFee) +
    toNumberOrZero(doctor.serviceFee) +
    toNumberOrZero(doctor.otherFee)
  );
};
